import { gql } from '__generated__';

export default gql(`
  query GetTicketsAndProductsForPurchase($event_id: ID!) {
    event(id: $event_id) {
      id
      tickets {
        id
        title
        units
        is_sold_out
        promotions {
          id
          title
          amount
          is_sold_out
          standard
        }
        time_slots {
          id
          start_date
          start_time
          title
          multi_date
          is_sold_out
        }
      }
      products {
        id
        title
        is_sold_out
        promotions {
          id
          title
          amount
          is_sold_out
          standard
        }
        product_variants {
          id
          title
          is_sold_out
        }
      }
      coupons {
        id
        type
        prefix
        value
        available
        codes_count
        code {
          id
          value
        }
      }
      invitations {
        id
        prefix
        available
        has_unique_codes
        code {
          id
          value
        }
      }
    }
  }
`);
